module.exports = __webpack_public_path__ + "static/media/CSE 12X.3d7e91b4.jpg";